<template>
  <div class="candidate-toolbar">
    <form class="control-search" @submit.prevent="$emit('search', { force: true })">
      <svg class="search-icon" viewBox="0 0 24 24" aria-hidden="true">
        <circle cx="10" cy="10" r="7" />
        <path d="m15 15 6 6" />
      </svg>
      <input
        ref="input"
        :value="keyword"
        :placeholder="placeholder"
        :aria-label="placeholder"
        @input="$emit('input', $event.target.value)"
        @blur="$emit('search')"
      />
      <button v-if="keyword" type="button" @mousedown.prevent @click="clear">清空</button>
      <button type="submit">搜索</button>
    </form>
    <div class="candidate-filters">
      <label>
        <app-select
          label="区域"
          appearance="glass"
          :active="!!regionId && regionId !== '0'"
          :style="{ width: regionWidth + 'px' }"
          :value="regionId"
          :options="regionSelectOptions"
          @change="$emit('region', $event)"
        />
      </label>
      <button
        v-if="$store.state.regionnavigation.hasMore"
        class="control-link"
        :disabled="$store.state.regionnavigation.loading"
        @click="loadRegions"
      >
        更多区域
      </button>
      <label v-if="categoryOptions.length">
        <app-select
          label="类别"
          appearance="glass"
          :active="categoryCode !== 'all'"
          :value="categoryCode"
          :options="categorySelectOptions"
          @change="$emit('category', $event)"
        />
      </label>
      <span class="selected-count">已选 {{ selectedCount }}</span>
    </div>
  </div>
</template>
<script>
import AppSelect from '../../common/app-select/app-select'
import { requestNextRegionNavigationPage } from '@/common/region-navigation-data'
export default {
  components: { AppSelect },
  props: {
    keyword: String,
    placeholder: { type: String, default: '搜索区域或名称' },
    selectedCount: { type: Number, default: 0 },
    regionOptions: { type: Array, default: () => [] },
    categoryOptions: { type: Array, default: () => [] },
    regionId: [String, Number],
    categoryCode: String
  },
  computed: {
    regionSelectOptions() {
      return this.regionOptions.map(item => ({ value: String(item.id), label: item.name }))
    },
    categorySelectOptions() {
      return this.categoryOptions.map(item => ({ value: item.code, label: item.name }))
    },
    regionWidth() {
      const region = this.regionOptions.find(item => String(item.id) === String(this.regionId))
      return Math.min(200, Math.max(108, (region ? region.name.length : 4) * 14 + 50))
    }
  },
  methods: {
    clear() {
      this.$emit('clear')
      this.$refs.input.focus()
    },
    loadRegions() {
      requestNextRegionNavigationPage(this).catch(e =>
        this.$showTipsToast(3, e.message || '加载区域失败')
      )
    }
  }
}
</script>
<style scoped>
.candidate-toolbar {
  flex: none;
  padding: 0 2px 4px;
}
.control-search {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 42px;
  padding: 0 12px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.94);
}
.search-icon {
  flex: none;
  width: 18px;
  height: 18px;
  fill: none;
  stroke: #777;
  stroke-width: 1.5;
}
.control-search input {
  flex: 1;
  min-width: 0;
  height: 100%;
  border: 0;
  background: transparent;
  color: #282828;
  font-size: 15px;
  outline: none;
}
.control-search:focus-within {
  box-shadow: 0 0 0 2px rgba(78, 110, 242, 0.4);
}
.control-search input::placeholder {
  color: #999;
}
.control-search button {
  border: 0;
  padding: 0 4px;
  background: transparent;
  color: var(--primary-color);
  font-size: 15px;
  cursor: pointer;
}
.candidate-filters {
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 48px;
  flex-wrap: wrap;
}
.candidate-filters label {
  min-width: 0;
  max-width: 45%;
}
.selected-count {
  margin-left: auto;
  color: #999;
  font-size: 13px;
  white-space: nowrap;
}
</style>
